// extracted by mini-css-extract-plugin
export default {"tooltip":"Ip-z","sharingV2":"Jp-z","sharingIconsV2":"Kp-z","links":"Lp-z","link":"Mp-z","facebookV2":"Np-z","twitterV2":"Op-z","pinterestV2":"Pp-z"};